import { render } from "./DefaultListSectionSubList1Cmp.vue?vue&type=template&id=23a05bf0"
import script from "./DefaultListSectionSubList1Cmp.vue?vue&type=script&lang=js"
export * from "./DefaultListSectionSubList1Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__